// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { Card, CardContent, Checkbox, FormControlLabel, Button , Radio, RadioGroup } from "@mui/material";
// import './style.css'
// import "../style.css"
// import anmolLogo from "../../assets/images/anmol_logo_transparent.png"
// import { ToastContainer, toast } from "react-toastify";

// export default function CustomerType() {
//   const toastId= React.useRef(null)
//    const [selectedOption, setSelectedOption] = useState("");
//    const [selectedCard, setSelectedCard] = useState(""); 
//   const [msme, setMsme] = useState(false);
//   const [fssi, setFssi] = useState(false);
//   const [others, setOthers] = useState(false);
//   const [noSelected, setNoSelected]= useState("");
//   const navigate = useNavigate();

//   // Load values from localStorage when the component mounts
 

//   // Update localStorage when state changes

//   const handleMsmeChange=(e)=>{
//     setMsme(e.target.checked);
//   }
//   const handleFssiChange=(e)=>{
//     setFssi(e.target.checked)
//   }

//   const handleCardSelection = (card) => {
//     setSelectedCard(card);
//   };
 

//   const handleProceed = () => {
//       if(selectedCard===""){
//         if(!toast.isActive(toastId.current)){
//           toastId.current= toast.warning("Please select a customer type",{
//                     className: "small-toast"
//                   })
//         }
//         return;
//       }else{
//         localStorage.setItem("customer_type",selectedCard);
//         navigate("/customer/registration-form")
//         return;
//       }
//   };

//   return (
//     <>
//     <ToastContainer/>
//     <div className="container">
//     <div className="image-container">
//       <img src={anmolLogo} alt="Business Image" className="business-image" />
//     </div>

//     <h2 className="title">Select Your Type:</h2>

//     <div className="checkbox-cards-container">
//       {/* First Card: Business Registrations */}
//       <div className={`checkbox-card `}>
//         <FormControlLabel
//           control={
//             <Radio
//               sx={{ color: "#01040a" }}
//               checked={selectedCard==="distributor"}
//               onChange={() => handleCardSelection("distributor")}
//             />
//         }
//         label={<span className="checkbox-label">Distributor</span>}
//         />
       
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "railway_distributor"}
//               onChange={() => handleCardSelection("railway_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">Railway Distributor</span>}
//         />
//       </div>

//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "super_stockist"}
//               onChange={() => handleCardSelection("super_stockist")}
//             />
//           }
//           label={<span className="checkbox-label">Super Stockist</span>}
//         />
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "sub_distributor"}
//               onChange={() => handleCardSelection("sub_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">Sub Distributor</span>}
//         />
//       </div>

//       <div className={`checkbox-card `}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "sitting_sub_distributor"}
//               onChange={() => handleCardSelection("sitting_sub_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">Sitting Sub Distributor</span>}
//         />
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "smt_distributor"}
//               onChange={() => handleCardSelection("smt_distributor")}
//             />
//           }
//           label={<span className="checkbox-label">SMT Distributor</span>}
//         />
//       </div>
//       <div className={`checkbox-card`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "modern_trade_cpc"}
//               onChange={() => handleCardSelection("modern_trade_cpc")}
//             />
//           }
//           label={<span className="checkbox-label">Modern Trade/ CPC/ Ecommerce</span>}
//         />
//       </div>



//       {/* Second Card: Others */}
//       {/* <div className={`checkbox-card ${selectedCard === "others" ? "active" : ""}`}>
//         <FormControlLabel
//           control={
//             <Radio
//             // disabled={selectedCard==="business"}
//               sx={{ color: "#01040a" }}
//               checked={selectedCard === "others"}
//               onChange={() => handleCardSelection("others")}
//             />
//           }
//           label={<span className="checkbox-label">Others</span>}
//         />
//       </div> */}
//     </div>

//     <Button variant="contained" sx={{ color: "ivory", marginTop: "30px" }} onClick={handleProceed} color="primary" className="proceed-button">
//       Proceed
//     </Button>
//   </div>
//     </>
  
//   );
// }


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormControlLabel, Checkbox, Button } from "@mui/material";
import "../style.css";
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import { ToastContainer, toast } from "react-toastify";
import { fetchEditable } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";

export default function VendorEditValidationFinal() {
  const toastId = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [refID,setRefID]= useState(localStorage.getItem("reference_id")|| "");
  const navigate = useNavigate();
  const [isActive,setIsActive]= useState(false);

  const [formValues, setFormValues] = useState({
            trade_name: { value: '', error: false }, // Trade Name(as per gst)*
            address: { value: '', error: false }, // Address(as per gst)*
            // street: { value: '', error: false }, // Address(to be registered as per GST)*
            // house_no: { value: '', error: false }, // House No.
            // city: { value: '', error: false }, // City*
            // state: { value: '', error: false }, // State*
            // pin_code: { value: '', error: false }, // Pin Code*
            type_of_firm: { value: '', error: false }, // Type of Firm/Company*
            cin: { value: '', error: false }, // CIN (if applicable)
            mca_roc_status: { value: '', error: false }, // MCA/ROC status (for Co/LLP)
            website: { value: '', error: false }, // Website
            proprietor_details: { value: '', error: false }, // Proprietor Details
            // proprietor_name: { value: '', error: false }, 
            // proprietor_email: { value: '' , error: false}, 
            // proprietor_mobile: { value: '' , error: false}, 
            pan: { value: '', error: false }, 
            contact_person_details: { value: '', error: false }, // Contact Person Details
            // contact_person: { value: '' , error: false}, // Name of Contact Person*
            // contact_person_email: { value: '', error: false }, // Mobile Number*
            // contact_person_mobile: { value: '', error: false },
            // contact_telephone: { value: '', error: false },
            // nature_of_business: { value: [],error: false }, // Nature of Business*
            // business_category: { value: [],error: false }, 
            msme_details: { value: '',error: false }, // MSME Details
            // msme_registration_status: { value: '',error: false }, // MSME Registration Status.
            // msme_registration_no: { value: '',error: false }, // MSME Registration no.
            // msme_category: { value: '',error: false }, // MSME Category
            // msme_type: { value: '',error: false }, // MSME Type
            fssai_details: { value: '',error: false }, // FSSI Details
            // fssai_registration_status: { value: '',error: false }, // FSSI Registration Status.
            // fssai_regn_no: { value: '',error: false }, // FSSI Regn No
            // fssai_valid_till: { value: '',error: false }, // FSSI Valid Till (dd-mm-yyyy)
            gstn: { value: '',error: false }, // GSTN No*.
            tan: { value: '',error: false }, // TAN*
            itr_filing_status: { value: '',error: false }, // Status of filing ITR of last 2 yrs.
            pan_linked_aadhaar: { value: '',error: false }, // PAN linked with Aadhaar
            gst_turnover_prev_yr: { value: '',error: false }, // GST Turnover of Prev Yr.(Lakhs).
            // prev_yr: { value: '',error: false }, // Prev Yr
            e_invoice_applicable: { value: '',error: false }, // E-Invoice Applicable
            bank_details: { value: '',error: false }, // Bank Details
            // bank_name: { value: '',error: false }, // Bank Name.
            // ifsc_code: { value: '',error: false }, // IFSC Code
            // bank_account_number: { value: '',error: false }, // Bank Account Number
            // cheque_issued_name: { value: '',error: false }, 
          });

      const handleCheckboxChange = (option) => {
        setSelectedOptions((prev) =>
          prev.includes(option)
            ? prev.filter((item) => item !== option)
            : [...prev, option]
        );
      };

      useEffect(() => {
        fetchAllEditableFields();
      },[])

      const fetchAllEditableFields= async()=>{
                  setIsActive(true);
                  const body={
                      module: "vendor"
                  }
                  console.log("body>> ", body)
                  try{
                      const response= await fetchEditable(body);
                      const res= response.data;
                      if(res.status){
                          setIsActive(false);
                          console.log("Editable fields response",res)
                          if(res.data){
                            const filteredFormValues = Object.keys(formValues).reduce((acc, key) => {
                              if (res.data[key] === 1) {
                                acc[key] = formValues[key];
                              }
                              return acc;
                            }, {});
                            setFormValues(filteredFormValues);
                          }
                      }else{
                          console.log("Could not fetch editable fields",res);
                          if(!toast.isActive(toastId.current)){
                              toastId.current= toast.error("Could Not fetch editable details",{
                                className:"small-toast"
                              })
                            }
                          setIsActive(false);
                      }
                  }catch(error){
                      console.log("Error while fetching editable fields",error)
                      setIsActive(false);
                      if(!toast.isActive(toastId.current)){
                          toastId.current= toast.error(error.message,{
                            className:"small-toast"
                          })
                        }
                       if(error.response?.status==403){
                                                  if(!toast.isActive(toastId.current)){
                                                    toastId.current= toast.error("Your Session has expired",{
                                                      className:"small-toast"
                                                    })
                                                  }
                                                  setTimeout(()=>{
                                                    navigate("/")
                                                    localStorage.clear();
                                                  },2000)
                                                  return;
                                                }
                              }
                }
      

  const handleProceed = () => {
    if (selectedOptions.length === 0) {
      if (!toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Please select at least one vendor field to edit", {
          className: "small-toast",
        });
      }
      return;
    }
    localStorage.setItem("selected_fields", JSON.stringify(selectedOptions));
    navigate("/vendor/edit/registration-form");
  };

  return (
    <>
      <ToastContainer />
      <SimpleBackdrop openLoader={isActive} />
      <div className="container">
        <div className="image-container">
          <img src={anmolLogo} alt="Business" className="business-image" />
        </div>
  
        <h2 className="title">Select The Fields You Want to Edit:</h2>
  
        <div className="checkbox-cards-container">
          {Object.keys(formValues).map((key) => {
            const formattedLabel = key
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase());
            return (
              <div key={key} className="checkbox-card">
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ color: "#01040a" }}
                      checked={selectedOptions.includes(key)}
                      onChange={() => handleCheckboxChange(key)}
                    />
                  }
                  label={<span className="checkbox-label">{formattedLabel}</span>}
                />
              </div>
            );
          })}
        </div>
  
        <Button
          variant="contained"
          sx={{ color: "ivory", marginTop: "30px" }}
          onClick={handleProceed}
          color="primary"
          className="proceed-button"
        >
          Proceed
        </Button>
      </div>
    </>
  );
}

